<template>

  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-0 mt-1">
      <b-btn block href="#" v-b-toggle.acis_struct variant="info" class="text-left">{{ dealName }} Structure</b-btn>
    </b-card-header>
    <b-collapse id="acis_struct" @show="lazyLoad">
      <b-card-body>
        <b-row>
          <b-col :cols="shouldCreatePortfolio ? 10 : 7">
            <b-row
                class="text-left"
                v-if="!flagStructureIsEmpty"
            >
              <b-col>
                <b-form-checkbox
                    :inline="true"
                    v-model="shouldCreatePortfolio"
                    class="text-left mb-3"
                    @change="onInitPortfolio"
                >
                  Create portfolio from {{ dealName }}
                </b-form-checkbox>
                <b-btn
                    v-if="shouldCreatePortfolio"
                    variant="primary"
                    class="ml-1 mb-1"
                    v-on:click="runAllBondsCalculation()"
                >
                  Run All Bonds Scenario
                </b-btn>
              </b-col>
            </b-row>
            <table class="table table-sm table-hover" v-if="!flagStructureIsEmpty">
              <thead>
              <tr>
                <th class="text-right sticky">STACR Deal Name</th>
                <th class="text-right sticky">STACR Bond Name</th>
                <th class="text-right sticky">ACIS Bond Name</th>
                <th class="text-right sticky">Original Balance</th>
                <th class="text-right sticky">Current Balance</th>
                <th class="text-right sticky">Factor</th>
                <th class="text-right sticky">Premium</th>
                <th class="text-right sticky" v-if="shouldCreatePortfolio">Initial Limit ($)</th>
                <th class="text-right sticky" v-if="shouldCreatePortfolio">Collateral (%)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="bond in structure.Bonds" :key=bond.AcisBondName>
                <td class="text-right text-nowrap">{{ structure.StacrDealName }}</td>
                <td class="text-right">{{ bond.StacrBondName }}</td>
                <td class="text-right">{{ bond.AcisBondName }}</td>
                <td class="text-right">{{ bond.OriginalBalance }}</td>
                <td class="text-right">{{ bond.CurrentBalance }}</td>
                <td class="text-right">{{ bond.Factor }}</td>
                <td class="text-right">{{ bond.Premium }}</td>
                <td class="text-right" style="min-width: 110px" v-if="shouldCreatePortfolio">
                  <b-form-input v-model="bond.OwnedFaceAmt" class="calculation-settings-input text-right" :formatter="formatUSD" lazy-formatter></b-form-input>
                </td>
                <td class="text-right" v-if="shouldCreatePortfolio">
                  <b-form-input v-model="bond.Margin" class="calculation-settings-input text-right"></b-form-input>
                </td>
              </tr>
              </tbody>
            </table>
            <b-row>
              <b-col cols="8"/>
              <b-col cols="4">
                <b-input-group v-if="shouldCreatePortfolio">
                  <b-form-input v-model="portfolioName" placeholder="Portfolio name"></b-form-input>
                  <b-input-group-append>
                    <b-btn class="float-right" variant="primary" @click="createPortfolio">Create</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import formatter     from '@/utilities/Formatter';
import service       from '@/services/HttpRequestService';
import {TRACE_ERROR} from '@/constants';
import UtilsData     from "@/utilities/UtilsData";

export default {
  props: {
    dealName:  String,
    structure: {
      type:    Object,
      default: function () {
        return {
          DealName:      '',
          StacrDealName: '',
          Bonds:         []
        }
      }
    }
  },
  data() {
    return {
      shouldCreatePortfolio: false,
      portfolioName:         ''
    };
  },
  watch:    {
    shouldCreatePortfolio(newVal) {
      if (newVal) {
        this.onInitPortfolio();
      }
    }
  },
  computed: {
    flagStructureIsEmpty() {
      return UtilsData.isEmpty(this.structure)
          ||
          (
              this.structure.hasOwnProperty('Bonds')
              &&
              UtilsData.isEmpty(this.structure.Bonds)
          )
    }
  },
  methods:  {
    lazyLoad() {
      if (this.flagStructureIsEmpty) {
        this.$emit('showStructure')
      }
    },
    onInitPortfolio() {
      for (let i = 0; i < this.structure.Bonds.length; i++) {
        if (UtilsData.isEmpty(this.structure.Bonds[i].OwnedFaceAmt))
          this.structure.Bonds[i].OwnedFaceAmt = this.structure.Bonds[i].OriginalBalance;
        if (UtilsData.isEmpty(this.structure.Bonds[i].Margin))
          this.structure.Bonds[i].Margin = 20.0;
      }
    },
    formatUSD: function (val, event) {
      return formatter.formatDollarValue(val);
    },
    async createPortfolio() {
      this.$emit('inputError', '');
      if (this.portfolioName == '') {
        this.$emit('inputError', "Portfolio name mustn't be empty.");
        return;
      }
      this.$emit('showSpinner');
      let entries = [];
      for (let i = 0; i < this.structure.Bonds.length; i++) {
        let bond = this.structure.Bonds[i];
        if (
            bond.OwnedFaceAmt == undefined ||
            bond.Margin == undefined ||
            parseFloat(bond.OwnedFaceAmt) <= '0.00' ||
            parseFloat(bond.Margin) <= '0'
        ) {
          continue;
        }
        entries.push({
          DealName:      this.structure.DealName,
          BondName:      bond.AcisBondName,
          OwnedFaceAmt:  bond.OwnedFaceAmt,
          Margin:        bond.Margin,
          AnnualPremium: 0,
          Cpr:           [0],
          Cdr:           [0],
          LossSeverity:  [0],
          Delinquency:   [0],
          Libor:         [0],
          OrdinalNumber: entries.length + 1
        });
      }
      if (entries.length > 0) {
        let body = {
          Name:             this.portfolioName,
          PortfolioType:    'Reinsurance',
          PortfolioEntries: entries
        };
        try {
          let res = await service.addPortfolio(body);
          if (res.status == 200) {
            this.$router.push({path: 'portfolio', query: {name: this.portfolioName}});
          }
        } catch (err) {
          await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
          this.$emit('inputError', err.response.data.Message);
        }
      } else {
        this.$emit('inputError', 'Provide contract amount and collateral for at least one bond.');
      }
      this.$emit('hideSpinner');
    },
    runAllBondsCalculation() {
      this.$emit('runAllBondsCalculation', true);
    }
  }
};
</script>
